import React from "react";
import { Sidebar } from "../Sidebar";

const LoadingState = ({ message = "Chargement...", embedded = false }) => {
  const content = (
    <div className="flex justify-center items-center h-full">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <div className="text-xl text-gray-600">{message}</div>
      </div>
    </div>
  );

  if (embedded) {
    return <div className="p-4">{content}</div>;
  }

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 p-4 overflow-auto">{content}</div>
    </div>
  );
};

export default LoadingState;
